import React from 'react';
import { Link } from 'react-router-dom';

import { MDText } from 'i18n-react';

import { HOMEPAGE_SNOW_PLOW_EVENTS } from 'Utilities/analytics/analyticsHomePage';

import { CAR_PRIZE_JUN_26_URL } from './CarPrizeJun2026.helpers';
import LocalTexts from './CarPrizeJun2026.texts.json';

import styles from './CarPrizeJun2026.scss';

const LocalT = new MDText(LocalTexts);

export const CarPrizeJun2026Banner = () => (
  <Link
    data-thc-style-override
    className={styles.banner}
    onClick={() => HOMEPAGE_SNOW_PLOW_EVENTS.CAR_PRIZE_CLICKED(`${LocalT.translate('banner.content')}`)}
    to={CAR_PRIZE_JUN_26_URL}
  >
    {LocalT.translate('banner.content')}
  </Link>
);
